<script setup lang="ts">
type Props = {
  as?: string;
};

const { as = "div" } = defineProps<Props>();
</script>

<template>
  <component
    :is="as"
    class="product-card-skeleton__item"
    data-test="product-card-skeleton"
  >
    <div class="product-card-skeleton__item-image">
      <BaseSkeletonLoader
        :width="400"
        :height="500"
      />
    </div>
    <div class="product-card-skeleton__item-info">
      <BaseSkeletonLoader />
    </div>
  </component>
</template>

<style lang="postcss">
.product-card-skeleton {
  &__item {
    @apply flex flex-col min-w-full gap-x-1;
    @apply w-2/3 min-w-[calc(66.66%-.17rem)];
    @apply md:w-1/3 md:min-w-[calc(33.33%-.17rem)];
    @apply lg:w-1/4 lg:min-w-[calc(25%-0.18rem)];
    @apply 3xl:w-1/5 3xl:min-w-[calc(20%-.23rem)];
  }

  &__item-image {
    @apply aspect-[4/5];
    @apply overflow-hidden;

    svg {
      @apply h-full;
    }
  }

  &__item-info {
    height: 68px;
    margin-top: 4px;
    @apply overflow-hidden;
  }
}
</style>
